import { faker, fakerEN_US } from '@faker-js/faker';

/**
 * Seeded Faker wrapper — the project mock surface should import `faker` from
 * here instead of directly from `@faker-js/faker` so mock data is deterministic
 * (stable across reloads, test runs, and snapshots).
 *
 * This mirrors the senet baseline wrapper (`src/mocks/utils/faker.ts`). Dexter
 * seeds unconditionally rather than gating on `VITE_E2E_MODE`: as an internal
 * lab, deterministic mocks are always desirable and keep the PD distribution
 * and derived fixtures reproducible. Seeding the shared faker singleton once at
 * module load makes every consumer that imports from this wrapper deterministic.
 */
faker.seed(12345);

export { faker, fakerEN_US };
